import { createApi } from "@reduxjs/toolkit/query/react";
import { endpoints } from "consts";

import {
  GetMediaProductsResponseDto,
  UpdateMediaProductsRequestDto,
} from "types/media";

import { coreQuery } from "utils/baseQuery";

export const mediaAPI = createApi({
  reducerPath: "mediaAPI",
  baseQuery: coreQuery(),
  tagTypes: ["media-products"],
  endpoints: build => ({
    getProductsMediaById: build.query<
      GetMediaProductsResponseDto,
      { providerId: string }
    >({
      query: ({ providerId }) => ({
        url: `${endpoints.media}/products/provider/${providerId}`,
        method: "GET",
      }),
      providesTags: ["media-products"],
    }),
    updateProductMedia: build.mutation<
      GetMediaProductsResponseDto,
      UpdateMediaProductsRequestDto
    >({
      query: ({ providerId, media }) => ({
        url: `${endpoints.media}/products/${providerId}`,
        method: "PUT",
        data: { media },
      }),
      invalidatesTags: ["media-products"],
    }),
    updateLazyProductMedia: build.mutation<
      GetMediaProductsResponseDto,
      UpdateMediaProductsRequestDto
    >({
      query: ({ providerId, media }) => ({
        url: `${endpoints.media}/products/${providerId}`,
        method: "PUT",
        data: { media },
      }),
    }),
  }),
});

export const {
  useGetProductsMediaByIdQuery,
  useUpdateProductMediaMutation,
  useUpdateLazyProductMediaMutation,
} = mediaAPI;
